import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {OrderService} from "../../order/order.service";
import {OrderWorkflowService} from "./order-workflow.service";
import {DialogRejectOrderComponent} from "./dialog-reject-order.component";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {OrderFormGqlModel} from "../../order/order-form.gql-model";

@Component({
  templateUrl: "./place-orders.template.pug",
  providers: [OrderService, DialogService, OrderWorkflowService],
})
export class PlaceOrdersComponent extends WorkflowStep {
  error: Error;

  waitingForRequest: boolean = false;
  canPlaceOrder: boolean = false;
  orderPlaced: boolean = false;
  orderCanBeRejected: boolean = false;

  orderForm: OrderFormGqlModel = new OrderFormGqlModel({});

  editableFields: {[key: string]: boolean} = {
    erpAccount: true,
    salValNumber: true,
    opgNumber: true,
    extraPricingInformation: true,
    orderResults: true,
    orderNotificationEmailList: true,
  };

  @toggleLoading()
  @handleErrors()
  async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    const orderRequested = this.workflowService.workflowConfig.target["orderRequested"];
    const orderPlaced = this.workflowService.workflowConfig.target["orderPlaced"];

    if (!orderRequested) this.waitingForRequest = true;
    else if (!orderPlaced) this.canPlaceOrder = true;
    else this.orderPlaced = true;

    this.orderCanBeRejected = await this.orderWorkflowService.getOrderCanBeRejected(
      workflowTargetInfo.targetId,
      this.workflowService.workflowConfig.id,
    );

    this.orderForm = await this.orderService.getOrderForm(workflowTargetInfo.targetId);

    if (!this.orderForm.header.orderAcceptanceCompleted) {
      this.error = new Error("Order Acceptance has not been completed for this project.  Fix this in project setup.");
    }
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    await this.orderService.confirmOrderPlaced(this.workflowTargetInfo.targetId);

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }

  @handleErrors()
  async rejectOrder() {
    const id = this.workflowTargetInfo.targetId;

    const success = await DialogRejectOrderComponent.showRejectOrderDialogModal(this.dialogService, id);

    if (success) {
      this.router.navigate(["/order"], {queryParams: {id}});
    }
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public orderService: OrderService,
    public dialogService: DialogService,
    public orderWorkflowService: OrderWorkflowService,
  ) {
    super(true);
    this.saveOnContinue = true;
  }
}
